export default __webpack_public_path__ + "static/media/B77.ffbb3060.png";